import dayjs from 'dayjs';
import React, { useState } from 'react';
import { Button, Calendar, Select, useMediaQueryContext } from '@fourthwall/components';
import { getRangeLabel } from '../../../../../utils/getRangeLabel';
import * as S from './DateRangeOptions.styled';
export const DateRangeOptions = ({ value, options, onSelect, onClose }) => {
    const media = useMediaQueryContext();
    const [selectedValue, setSelectedValue] = useState(value);
    const [calendarDates, setCalendarDates] = useState(value.dates);
    const handleApply = () => {
        onSelect(selectedValue);
        onClose?.();
    };
    const handleDatesChange = (dates) => {
        // Update calendar dates for display
        setCalendarDates(dates);
        // Check if selected dates match any predefined option
        const matchingOption = options.find((option) => {
            if (!option.dates)
                return false;
            const optionStartDate = dayjs(option.dates[0]);
            const optionEndDate = dayjs(option.dates[1]);
            const selectedStartDate = dayjs(dates[0]);
            const selectedEndDate = dayjs(dates[1]);
            return (optionStartDate.isSame(selectedStartDate, 'day') &&
                optionEndDate.isSame(selectedEndDate, 'day'));
        });
        if (matchingOption) {
            setSelectedValue(matchingOption);
            setCalendarDates(matchingOption.dates);
        }
        else {
            // Set first date to start of day (00:00:00) and second date to end of day (23:59:59)
            const normalizedDates = [
                dayjs(dates[0]).startOf('day').toDate(),
                dayjs(dates[1]).endOf('day').toDate(),
            ];
            setSelectedValue({ dates: normalizedDates });
        }
    };
    const handleSelectValueChange = (value) => {
        const selectedOption = options.find((option) => option.value === value);
        if (selectedOption) {
            setSelectedValue(selectedOption);
            setCalendarDates(selectedOption.dates);
        }
    };
    const renderOptions = () => {
        if (!media.tablet) {
            return (React.createElement(S.OptionsSelect, null,
                React.createElement(Select, { value: selectedValue.value, label: "Select range", size: "small", options: options.map(({ value, label }) => ({
                        value,
                        label,
                    })), onValueChange: handleSelectValueChange })));
        }
        return (React.createElement(S.OptionsList, { maxHeight: 354, maskPercentage: 8, hideScrollbar: true }, options.map((option) => (React.createElement(S.OptionsListItem, { key: option.value, "$selected": selectedValue.value === option.value, onClick: () => {
                setSelectedValue(option);
                setCalendarDates(option.dates);
            } }, option.label)))));
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.Main, null,
            renderOptions(),
            React.createElement(S.CalendarWrapper, null,
                React.createElement(Calendar, { key: calendarDates[0]?.toString(), type: "range", bare: true, selectedDates: calendarDates, maxDate: new Date(), showTimeInputs: false, onDatesChange: handleDatesChange }))),
        React.createElement(S.Footer, null,
            React.createElement(S.DateRangeLabel, null, getRangeLabel(selectedValue.dates)),
            React.createElement(S.Actions, null,
                React.createElement(Button, { label: "Cancel", size: media.tablet ? 'small' : 'medium', appearance: "secondary", fullWidth: !media.tablet, onClick: onClose }),
                React.createElement(Button, { label: "Apply", size: media.tablet ? 'small' : 'medium', appearance: "primary", fullWidth: !media.tablet, onClick: handleApply })))));
};
